export default __webpack_public_path__ + "static/media/moodboard_logo.2beeb958.png";